import http from './httpService';

let apiEndpoint = '/contacts';

export function getContactData() {
  return http.get(`${apiEndpoint}`);
}